export default __webpack_public_path__ + "static/media/nutri2.6aa252fd.jpg";